import {
    takeEvery, call, put, fork
  } from 'redux-saga/effects';
  import { loadIsler, saveIsler } from 'src/utils/storage/WorkOrder';
  import { setIslerAdet } from 'src/utils/storage/NavBarAdet';
  import * as actions from '../actions/taskActions';
  import * as api from '../api/tasks';
  
  function* getUndatedTasks() {
    try {
      let result = '';
      if (window.navigator.onLine) {
        result = yield call(api.getUndatedTasks);
        // saveIsler(result.data);
        // setIslerAdet(result.data.length);
        yield put(actions.getTasksSuccess(result.data));
      } else {
        result = loadIsler();
        // setIslerAdet(result.length);
        yield put(actions.getTasksSuccess(result));
      }
    } catch (error) {
      const resultError = loadIsler();
    //   setIslerAdet(resultError.length);
      yield put(actions.getTasksSuccess(resultError));
    }
  }
  
  function* watchGetTaskRequest() {
    yield takeEvery(actions.Types.GET_UNDATEDTASK_REQUEST, getUndatedTasks);
  }
  
  const undatedtaskSagas = [fork(watchGetTaskRequest)];
  
  export default undatedtaskSagas;
  